import React from 'react';
import type { ImageProps } from 'next/image';
import Image from 'next/image';
import { urlForCmsAsset } from '@/lib/urlForCmsAsset';
import type { CmsImageData } from '@/services/cms/models/CmsImageData';

export type CmsImageProps = CmsImageData & Omit<ImageProps, 'src' | 'className' | 'height' | 'width' | 'alt' | 'id' | 'title'>;

export const CmsImage = React.forwardRef<HTMLImageElement, CmsImageProps>(({ ...props }, ref) => (
    <Image
        ref={ref}
        src={urlForCmsAsset(props)}
        alt={props.title || props.name}
        width={props.width}
        height={props.height}
        loading={props.loading}
        style={props.style}
        sizes={props.sizes}
        quality={props.quality}
        priority={props.priority}
        placeholder={props.placeholder}
        blurDataURL={props.blurDataURL}
        fill={props.fill}
        loader={props.loader}
        unoptimized={props.unoptimized}
        overrideSrc={props.overrideSrc}
        onLoadingComplete={props.onLoadingComplete}
        layout={props.layout}
        objectFit={props.objectFit}
        objectPosition={props.objectPosition}
        lazyBoundary={props.lazyBoundary}
        lazyRoot={props.lazyRoot}
    />
));
CmsImage.displayName = 'CmsImage';
